import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={{background:"#071428",color:"rgba(255,255,255,0.45)",padding:"64px 5vw 32px"}}>
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:48,maxWidth:1200,margin:"0 auto 48px"}}>
        <div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
            <div style={{width:36,height:36,borderRadius:"50%",background:"linear-gradient(135deg,#C9963E,#E8B96A)",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Playfair Display',serif",fontWeight:900,color:"#0B1F3A",fontSize:15}}>RF</div>
            <div>
              <div style={{fontFamily:"'Playfair Display',serif",color:"white",fontSize:15,fontWeight:700}}>Revolutionary Foundation</div>
              <div style={{fontSize:10,color:"#E8B96A",letterSpacing:1.5,textTransform:"uppercase"}}>Est. 2019 · Nigeria</div>
            </div>
          </div>
          <p style={{fontSize:13,lineHeight:1.8}}>A transparent, community-focused nonprofit committed to distributing resources where they matter most across Nigeria.</p>
        </div>
        {[
          ["Foundation",[["About Us","/about"],["Programs","/programs"],["Impact","/impact"],["Leadership","/about#team"]]],
          ["Get Involved",[["Apply for Grant","/apply"],["Become a Member","/membership"],["Volunteer","/contact"],["Donate","/contact"]]],
          ["Contact",[["revolutionaryfoundation.org.ng@gmail.com","mailto:revolutionaryfoundation.org.ng@gmail.com"]]],
        ].map(([title,links])=>(
          <div key={title}>
            <h4 style={{color:"white",fontSize:12,fontWeight:600,letterSpacing:1.5,textTransform:"uppercase",marginBottom:18}}>{title}</h4>
            {links.map(([label,to])=>(
              <a key={label} href={to} style={{display:"block",fontSize:13,color:"rgba(255,255,255,0.4)",marginBottom:10,transition:"color 0.2s"}} onMouseEnter={e=>e.target.style.color="#E8B96A"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,0.4)"}>{label}</a>
            ))}
          </div>
        ))}
      </div>
      <hr style={{border:"none",borderTop:"1px solid rgba(255,255,255,0.06)",maxWidth:1200,margin:"0 auto 28px"}}/>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",maxWidth:1200,margin:"0 auto",fontSize:12,flexWrap:"wrap",gap:12}}>
        <span>© {new Date().getFullYear()} Revolutionary Foundation. All rights reserved. · <Link to="/terms" style={{color:"rgba(255,255,255,0.35)"}}>Terms & Conditions</Link></span>
        <span style={{color:"#E8B96A",fontWeight:500,letterSpacing:1}}>Transparency · Equity · Impact</span>
        <div style={{display:"flex",gap:16}}>
          {[
            ["Twitter", "#"],
            ["Facebook", "#"],
            ["LinkedIn", "#"],
            ["Instagram", "#"],
            ["Telegram", "https://t.me/+yOAUtwNa9DMzODhk"]
          ].map(([s, url])=>(
            <a key={s} href={url} target="_blank" rel="noopener noreferrer" style={{color:"rgba(255,255,255,0.35)",fontSize:12,transition:"color 0.2s"}} onMouseEnter={e=>e.target.style.color="#E8B96A"} onMouseLeave={e=>e.target.style.color="rgba(255,255,255,0.35)"}>{s}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
